import api from '../../utils/api';
import {
    SEARCH_AUDIT_LOGS,
    GET_AUDIT_LOG_DETAIL,
    ROLLBACK_AUDIT_LOG,
    GET_AUDIT_LOG_MODELS
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * Tìm kiếm danh sách audit logs theo bộ lọc
 * @param {Object} filters { model, user_id, from, to, page, per_page }
 */
export const searchAuditLogs = (filters) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/audit-logs/search', { params: filters }).then(res => {
            dispatch({ type: SEARCH_AUDIT_LOGS, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Lỗi tìm kiếm log');
            reject(err);
        });
    });
};

/**
 * Xem chi tiết 1 audit log cụ thể
 * @param {number} id     ID của bản ghi cần lấy log
 */
export const viewAuditLogDetail = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/audit-logs/log/${id}`).then(res => {
            dispatch({ type: GET_AUDIT_LOG_DETAIL, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Không thể lấy lịch sử log');
            reject(err);
        });
    });
};

/**
 * Rollback dữ liệu từ 1 log cụ thể
 * @param {number} logId
 */
export const rollbackAuditLog = (logId) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post(`/audit-logs/${logId}/rollback`).then(res => {
            dispatch({ type: ROLLBACK_AUDIT_LOG, payload: res.data.data });
            NotificationManager.success(res.data.msg || 'Rollback thành công');
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Rollback thất bại');
            reject(err);
        });
    });
};

/**
 * Lấy danh sách các model đã từng ghi log để hiển thị trong bộ lọc.
 */
export const getAuditLogModels = () => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/audit-logs/models')
            .then(res => {
                dispatch({
                    type: GET_AUDIT_LOG_MODELS,
                    payload: res.data, // mảng ['Customer', 'Labo', ...]
                });
                resolve(res.data);
            })
            .catch(err => {
                NotificationManager.error(err.response?.data?.msg || 'Không thể tải danh sách model');
                reject(err);
            });
    });
};
